import { TABLE_HEADER_INDEX } from 'constans/statisticsTableConstants';
import React from 'react';
import { v4 as uuidV4 } from 'uuid';
import './ContentStatisticsTable.scss';

const ContentStatisticsTable = ({ tableContent }) => {
  const createKey = (index, value) => {
    if (value) {
      return index + value;
    }

    return index + uuidV4();
  };

  return (
    <tbody>
      {tableContent.map((item, index) => {
        return (
          <tr key={index} className={'dashboard-statistics-table__content'}>
            <td key={'index_' + index} className={'dashboard-statistics-table__content__item'}>
              {index + 1}
            </td>
            {item.map((property, propertyIndex) => {
              return (
                <td key={createKey(index, property)} className={'dashboard-statistics-table__content__item'}>
                  {propertyIndex === TABLE_HEADER_INDEX['DATE_CHECK'] && new Date(property).toDateString()}
                  {propertyIndex !== TABLE_HEADER_INDEX['DATE_CHECK'] && property}
                </td>
              );
            })}
          </tr>
        );
      })}
    </tbody>
  );
};

export default ContentStatisticsTable;
